import videoPlayer from "@/components/videoPlayer/videoPlayer.vue"
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide } from 'vue3-carousel'

export default {
    components: {
        videoPlayer, Carousel, Slide
    },

    props: {
        linksList: {
            type: Array,
            require: true,
        },
    },
}
